<script setup lang="ts">
import CustomRadioButton from '@/core/elements/CustomRadioButton.vue';
import { ref, toRefs, useId, watch } from 'vue';

export interface IRadioGroupOption {
  label: string;
  value: boolean;
}

interface IEmits {
  (event: 'update:options', data: IRadioGroupOption[]): void;
}
const emit = defineEmits<IEmits>();

const props = defineProps<{
  options: IRadioGroupOption[];
  disabled?: boolean;
}>();
const { options, disabled } = toRefs(props);

const optionsInternal = ref<IRadioGroupOption[]>([]);
const name = ref<string>(useId());

const handleOptionSelected = (option: IRadioGroupOption): void => {
  optionsInternal.value = optionsInternal.value.map((o) => ({
    ...o,
    value: o.label === option.label,
  }));
  emit('update:options', optionsInternal.value);
};

watch(
  options,
  () => {
    optionsInternal.value = options.value;
  },
  { immediate: true },
);
</script>

<template>
  <div class="flex flex-col">
    <div v-for="option in options" :key="option.label" class="flex items-center gap-sm">
      <CustomRadioButton
        :model-value="option.value"
        :name="name"
        :label="option.label"
        :disabled="disabled"
        @update:model-value="handleOptionSelected(option)"
      />
      <slot name="option" :option="option" />
    </div>
  </div>
</template>
